module.exports = __webpack_public_path__ + "img/pay-notice.6ba3205e.png";